import { Input } from "@/src/components/universalInput";
import { FieldsSection, Field, inputTypes } from "@/src/data/allTypes";
import {
  getFileType,
  getOptionsFromRecord,
  getUserId,
  uid,
} from "@/src/utils/utils";
import { useState } from "react";
import {
  ConditionGroupPickerButton,
  parseConditionGroup,
  stringifyConditionGroup,
} from "../../documents/documentConditions";
import ReorderableOptions from "./reorderableOptions";
import FieldUnitPicker from "./fieldUnitPicker";
import { openDrawer } from "@/src/components/dialogs";
import apiFetch from "@/src/utils/apiFetch";
import { Button } from "@/src/components/buttons";

export default function FieldForm({
  sections,
  currentData,
  onChange,
}: {
  sections: (FieldsSection | null | undefined)[];
  currentData?: Field;
  onChange: (newValue: Field) => void;
}) {
  let [field, setData] = useState(currentData || ({} as Field));
  const [isMultiple, setIsMultiple] = useState(false);
  const [showMoreOptions, setShowMoreOptions] = useState(false);

  function setNewValue(newValue: Field) {
    setData(newValue);
    onChange(newValue);
  }

  function getInputTypeValue() {
    if (field.type == "chips-multiple") return "chips";
    if (field.type == "select-multiple") return "select";
    if (field.type == "uploads") return "upload";
    return field.type;
  }

  function convertToMultiple(isMultiple: boolean) {
    if (field.type == "chips" && isMultiple) return "chips-multiple";
    if (field.type == "select" && isMultiple) return "select-multiple";
    if (field.type == "upload" && isMultiple) return "uploads";
    if (field.type == "chips-multiple" && !isMultiple) return "chips";
    if (field.type == "select-multiple" && !isMultiple) return "select";
    if (field.type == "uploads" && !isMultiple) return "upload";
    return field.type;
  }

  console.log("the field", field);

  return (
    <div className="grid gap10 c1">
      <Input
        name={"Nom"}
        type={"text"}
        shouldFocus={true}
        value={field.name}
        onChange={(newValue) => {
          setNewValue({ ...field, name: newValue });
        }}
      />

      <Input
        key={uid()}
        name={"Type"}
        type={"chips"}
        value={getInputTypeValue()}
        options={Object.values(inputTypes).filter((a) => a.shoudShowInForm)}
        onChange={(newValue) => {
          setNewValue({ ...field, type: newValue });
        }}
      />

      {[
        "chips",
        "chips-multiple",
        "select",
        "select-multiple",
        "upload",
        "uploads",
      ].includes(field.type) && (
        <Input
          name={"Multiple"}
          type={"chips"}
          value={isMultiple ? "true" : "false"}
          options={[
            { value: "true", label: "Oui" },
            { value: "false", label: "Non" },
          ]}
          onChange={(newValue) => {
            setIsMultiple(newValue === "true");
            setNewValue({
              ...field,
              type: convertToMultiple(newValue === "true"),
            });
          }}
        />
      )}

      {["select", "select-multiple", "chips", "chips-multiple"].includes(
        field.type
      ) && (
        <ReorderableOptions
          currentValue={field.options || []}
          onChange={(newOptions) => {
            console.log("the new freaaaking options", newOptions);
            setNewValue({ ...field, options: newOptions });
          }}
        ></ReorderableOptions>
      )}
      {field.type == "number" && (
        <>
          <FieldUnitPicker
            current={field.unit}
            title="Unité"
            onChange={(newValue) => {
              setNewValue({ ...field, unit: newValue });
            }}
          ></FieldUnitPicker>
          <div className="c2 gap10">
            <Input
              name={"Minimum"}
              type={"number"}
              value={field.min}
              onChange={(newValue) => {
                setNewValue({ ...field, min: newValue });
              }}
            />
            <Input
              name={"Maximum"}
              type={"number"}
              value={field.max}
              onChange={(newValue) => {
                setNewValue({ ...field, max: newValue });
              }}
            />
          </div>
        </>
      )}

      <Button
        type={"quaternary"}
        additionalStyle={{
          placeItems: "start",
        }}
        onClick={async () => {
          setShowMoreOptions(!showMoreOptions);
        }}
      >
        {showMoreOptions ? "Moins d'options" : "Plus d'options"}
      </Button>
      {showMoreOptions && (
        <>
          <Input
            name={"Valeur par défaut"}
            type={field.type}
            value={field.defaultValue}
            options={
              field.options
                .filter((a) => a)
                ?.map((option) => {
                  return { value: option!.id, label: option!.name };
                }) || []
            }
            onChange={(newValue) => {
              if (newValue == field.defaultValue) newValue = null;
              setNewValue({ ...field, defaultValue: newValue });
            }}
          />

          <Input
            name={"Requis"}
            type={"chips"}
            value={field.isRequired == true ? "true" : "false"}
            options={[
              { value: "true", label: "Oui" },
              { value: "false", label: "Non" },
            ]}
            onChange={(newValue) => {
              setNewValue({ ...field, isRequired: newValue === "true" });
            }}
          />

          <Input
            name={"Description"}
            type={"textarea"}
            value={field.description}
            onChange={(newValue) => {
              setNewValue({ ...field, description: newValue });
            }}
          />

          <ConditionGroupPickerButton
            current={parseConditionGroup(field.conditionGroupStr)}
            toolbarId={field.id || ""}
            sections={sections || []}
            onChange={(newValue) => {
              setNewValue({
                ...field,
                conditionGroupStr: stringifyConditionGroup(newValue),
              });
            }}
          ></ConditionGroupPickerButton>
        </>
      )}

      {/* <div className="field">
            <div className="label">Old ids</div>
            <MySelect
              isCreatable={true}
              isMultiple={true}
              value={field.oldIds}
              options={
                field.oldIds?.map((id) => {
                  return { value: id, label: id };
                }) || []
              }
              onChange={(newValue) => {
                setNewValue({ ...field, oldIds: newValue });
              }}
            />
          </div> */}
    </div>
  );
}

export async function openFieldForm({
  sections,
  current,
  onSave,
}: {
  sections: (FieldsSection | null | undefined)[];
  current: Field | null | undefined;
  onSave: (newValue: Field) => void;
}) {
  current ||= {
    name: "",
    description: "",
    defaultValue: "",
    placeholder: "",
    options: [],
    conditionGroupStr: null,
    type: "text",
    unit: null,
    creator: getUserId(),
  };

  await openDrawer({
    title: "Champ",

    content: (
      <FieldForm
        sections={sections}
        currentData={current}
        onChange={(newValue) => {
          current = newValue;
        }}
      />
    ),
    onConfirm: async () => {
      if (!current) return;
      current = await apiFetch("fields", "addOne", { field: current });
      onSave(current);
    },
  });
}
